import { render, staticRenderFns } from "./AppointmentTotalsComponent.vue?vue&type=template&id=4e8bbae4&"
import script from "./AppointmentTotalsComponent.vue?vue&type=script&lang=js&"
export * from "./AppointmentTotalsComponent.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentTotalsComponent.vue?vue&type=style&index=0&id=4e8bbae4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports